var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitacora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "83.000000pt",
    height: "88.000000pt",
    viewBox: "0 0 83.000000 88.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,88.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 862 c-15 -17 -17 -61 -17 -424 0 -380 1 -406 18 -421 16 -15 54 -17 330 -17 310 0 311 0 326 22 13 18 16 52 16 168 l0 146 70 69 c38 38 70 73 70 78 0 5 -11 6 -25 3 -28 -7 -31 0 -10 28 20 27 19 59 -4 87 -15 18 -28 23 -60 23 l-41 -1 0 106 c0 164 31 151 -344 151 -290 0 -314 -1 -329 -18z m641 -147 l3 -129 -160 -161 c-126 -127 -161 -167 -166 -195 -4 -19 -14 -50 -22 -68 -17 -35 -12 -52 10 -34 7 6 38 16 68 23 50 10 62 19 162 117 61 61 107 100 107 91 0 -9 -7 -22 -16 -30 -14 -12 -14 -14 0 -25 14 -10 16 -31 14 -140 l-3 -129 -310 0 -310 0 -3 395 c-1 217 0 401 3 408 3 10 71 12 312 10 l308 -3 3 -130z m106 -131 c25 -24 19 -47 -19 -84 l-35 -34 -33 32 -32 33 37 34 c42 39 59 43 82 19z m-193 -258 l-119 -119 -37 28 -36 28 123 124 122 123 33 -32 33 -32 -119 -120z m163 92 c-22 -21 -40 -34 -43 -27 -4 14 59 80 71 72 6 -3 -7 -23 -28 -45z m-324 -229 c0 -8 -50 -22 -57 -15 -3 2 -2 19 2 36 l7 32 24 -23 c13 -12 24 -26 24 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 735 c0 -13 32 -15 225 -15 193 0 225 2 225 15 0 13 -32 15 -225 15 -193 0 -225 -2 -225 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 664 c-20 -21 12 -24 219 -24 176 0 225 3 222 13 -4 9 -58 13 -219 15 -119 1 -218 -1 -222 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 581 c-17 -17 23 -21 221 -21 143 0 225 4 225 10 0 6 -3 10 -7 10 -204 4 -436 4 -439 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 488 c5 -14 145 -24 186 -13 50 12 5 25 -89 25 -76 0 -100 -3 -97 -12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitacora);
export default __webpack_public_path__ + "static/media/bitacora.38c98cc1331e24378b0c8636787019f2.svg";
export { ForwardRef as ReactComponent };